import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ClientAgreementType } from '@payer-admin-ui/api/src/clientagreements/models/ClientAgreementType';
import { ClientAgreementResponse } from '@payer-admin-ui/api/src/clientagreements/responses/ClientAgreementResponse';
import { clientAgreementsAPI } from './clientAgreementsAPI';

type AiAgreementsState = {
  aiAssistantAgreement: ClientAgreementResponse | null | undefined;
  isFetchingAiAssistantAgreement: boolean;
  isAcceptingAiAssistantAgreement: boolean;
  error: unknown | null;
};

const initialState: AiAgreementsState = {
  aiAssistantAgreement: undefined,
  isFetchingAiAssistantAgreement: false,
  isAcceptingAiAssistantAgreement: false,
  error: null,
};

export const fetchAiAssistantAgreement = createAsyncThunk<ClientAgreementResponse | null>(
  'ai/agreements/aiAssistant/fetch',
  async () => {
    return clientAgreementsAPI.getAgreement(ClientAgreementType.AI_ASSISTANT);
  },
);

export const acceptAiAssistantAgreement = createAsyncThunk<ClientAgreementResponse>(
  'ai/agreements/aiAssistant/accept',
  async () => {
    return clientAgreementsAPI.acceptAgreement(ClientAgreementType.AI_ASSISTANT, 1);
  },
);

const aiAgreementsSlice = createSlice({
  name: 'ai/agreements',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAiAssistantAgreement.pending, state => {
      state.isFetchingAiAssistantAgreement = true;
      state.error = null;
    });

    builder.addCase(fetchAiAssistantAgreement.fulfilled, (state, { payload }) => {
      state.isFetchingAiAssistantAgreement = false;
      state.aiAssistantAgreement = payload;
    });

    builder.addCase(fetchAiAssistantAgreement.rejected, (state, { error }) => {
      state.isFetchingAiAssistantAgreement = false;
      state.error = error;
    });

    builder.addCase(acceptAiAssistantAgreement.pending, state => {
      state.isAcceptingAiAssistantAgreement = true;
      state.error = null;
    });

    builder.addCase(acceptAiAssistantAgreement.fulfilled, (state, { payload }) => {
      state.isAcceptingAiAssistantAgreement = false;
      state.aiAssistantAgreement = payload;
    });

    builder.addCase(acceptAiAssistantAgreement.rejected, (state, { error }) => {
      state.isAcceptingAiAssistantAgreement = false;
      state.error = error;
    });
  },
});

export const { reducer: aiAgreementsReducer } = aiAgreementsSlice;
